import React, { useContext, useEffect, useState } from "react";
import { getChoresDiffrence, getDateHelper, getFrequencyDates, getFrequencyValue, getPriceHelper, isDateFinalized, setDateHelper, userDetails } from "../../utils/Helper";
import $ from 'jquery';
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import ReactSelect from "react-select";
import DatePicker from "react-datepicker";
import calLogo from '../../assets/images/calender.svg'
import Button from "../../components/ui/Button";
import { useForm } from "react-hook-form";
import moment from 'moment';
import { FREQUENCY_TYPES, HOUSEHOLD_TYPES } from "../../constants/Constants";
import { ErrorMessage } from "@hookform/error-message";
import { motion, AnimatePresence } from 'framer-motion';
import toast from "react-hot-toast";
import { yupResolver } from "@hookform/resolvers/yup";
import ValidationMessage from "../../constants/ValidationMessage";
import * as yup from 'yup';
import authContext from "../../context/authContext";
import Checkbox from "../../components/layouts/CheckBox";
import chevRight from '../../assets/images/chev-right.svg'
import ProfileImage from "../../components/layouts/ProfileImage";


interface expensesFilterInputs {
    hhMembers?: any; // Household members
    date?: string;
    payer?: any; // Payer
    s_between?: string[]; // Payer
    ec_id?: string; // Expenses id
    amount: string; // Amount,
    new_date?: string
    description?: string
};

const EditExpenses = ({ hhMembers, payers, expensesCategories, editExpense, onCancel, onSuccess, finalizedMonths }: any) => {

    let profile: any = useContext(authContext);
    profile = profile?.data;
    const updateExpense = useMakeRequest();
    const [isShareBetweenExpanded, setIsShareBetweenExpanded] = useState(false);

    const { register, watch, setValue, getValues, formState: { errors }, handleSubmit, trigger, reset } = useForm<expensesFilterInputs>({
        mode: 'onChange',
        resolver: yupResolver(
            yup.object().shape({
                amount: yup
                    .string()
                    .required(ValidationMessage.Field("an amount"))
                    .test(
                        'amount-required',
                        ValidationMessage.Field("an amount more than 0"),
                        function (value: any) {
                            const { amount } = this.parent;
                            if (Number(amount) === 0) return false;
                            return true;
                        }
                    ),
            })
        )
    });

    const onSubmit = (payload: any) => {
        console.log("payload:", payload)
        console.log("payload.payer:", payload.payer)
        const is_finalized = isDateFinalized(payload?.new_date, finalizedMonths || []);
        if (is_finalized) {
            toast.error("Selected date already finalized.")
            return;
        }

        let formInputs: any = {
            e_id: editExpense?.uuid,
            is_modified: editExpense?.is_modified,
            m_date: payload?.date,
            ec_id: payload?.ec_id?.value,
            payer: payload?.payer?.value,
            amount: payload?.amount,
            new_date: payload?.date === payload?.new_date ? null : payload?.new_date,
            desc: payload?.description ?? "",
            s_between: payload?.s_between
        }

        if (formInputs.payer == "01") {
            formInputs.payer = "0"
            formInputs.is_joint_account = "1"
        } else if (formInputs.payer == "0") {
            formInputs.payer = "0"
            formInputs.is_joint_account = "0"
        } else {
            formInputs.payer = payload.payer?.value
            formInputs.is_joint_account = null
        }
        updateExpense.makeRequest({
            url: ApiConstants?.ExpensesUpdate,
            payload: formInputs
        })
    }

    useEffect(() => {
        if (editExpense && payers?.length > 0 && expensesCategories?.data?.data?.length > 0) {
            console.log("editExpense: ", editExpense)
            setValue('date', editExpense?.date)
            setValue('new_date', editExpense?.date)
            setValue('amount', editExpense?.amount)
            setValue('ec_id', editExpense?.expense_cat)
            setValue('description', editExpense?.desc)
            // setValue('s_between', editExpense?.shared_between || []);
            // setValue('s_between', {
            //     value: editExpense?.paid_by?.value,
            //     label: profile?.uuid === editExpense?.paid_by?.value ? 'Me' : editExpense?.paid_by?.label
            // })
            if (editExpense?.is_joint_account == 1) {
                setValue('payer', {
                    value: "01",
                    label: "Joint Account"
                })
            } else {
                setValue('payer', {
                    value: editExpense?.paid_by?.value,
                    label: profile?.uuid === editExpense?.paid_by?.value ? 'Me' : editExpense?.paid_by?.label
                })
            }


            if (editExpense?.paid_by?.value !== "0" || editExpense?.paid_by?.value !== "01") {
                const allMemb: any = [];
                editExpense?.shared_between?.length > 0 &&
                    editExpense?.shared_between?.map((memb: any) => {
                        allMemb.push(memb?.split_user?.uuid);
                    });
                setValue("s_between", allMemb);
                trigger("s_between");
            }
        }
    }, [editExpense, payers, expensesCategories])


    useEffect(() => {
        if (updateExpense?.status) {
            onSuccess();
            reset();
            $('.btn-close-modal').click()
            setTimeout(() => {
                toast.success('Expense updated successfully.');
            }, 500);
        }
    }, [updateExpense?.status])


    const handleSelectShareBetween = (value: any) => {
        let prevSelected: any = watch("s_between");
        if (prevSelected.includes(value)) {
            prevSelected = prevSelected.filter((item: any) => item !== value);
        } else {
            prevSelected = [...prevSelected, value];
        }
        setValue("s_between", prevSelected);
        trigger("s_between");
    };

    return (

        <div className="modal fade bottom-sheet-modal" id="expensesUpdateModal" tabIndex={-1} aria-labelledby="expensesUpdateModalLabel" aria-hidden="true" data-bs-backdrop="true" data-bs-keyboard="true" >
            <div className="modal-dialog">
                <div className="modal-content">
                    {/* Bottom Sheet Handle */}
                    <div className="bottom-sheet-handle">
                        <div className="handle-bar"></div>
                    </div>

                    <div className="modal-header">
                        <h1 className="modal-title" id="expensesUpdateModal">Edit Expense</h1>
                    </div>

                    <div className="modal-body">
                        <form className="row gy-3" onSubmit={handleSubmit(onSubmit)}>
                            <div className='col-6'>
                                <div className="com-input-grp">
                                    <label className="form-label d-block">Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="MM/DD/YYYY"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        // selected={watch("s_date") as any}
                                        selected={watch('new_date') ? moment(watch('new_date')).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setValue('new_date', setDateHelper({ date: start_date }))
                                            trigger('new_date')
                                        }}
                                        minDate={
                                            profile?.hh_member?.member_type == HOUSEHOLD_TYPES?.ADMIN ?
                                                moment(profile?.hh_member?.billing_date).toDate() :
                                                moment(profile?.hh_member?.created_at).toDate()
                                        }
                                    // minDate={moment(profile?.hh_member?.billing_date).toDate()}
                                    />

                                    <ErrorMessage
                                        errors={errors}
                                        name="s_date"
                                        render={({ message }) => <p className='valid-error'>{message}</p>}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label">Amount</label>
                                    <div className='custom-select'>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter amount"
                                            {...register('amount')}
                                            onInput={(e: any) => {
                                                let inputValue = e.target.value;
                                                inputValue = inputValue.replace(/[^0-9.]/g, '');
                                                const decimalCount = inputValue.split('.').length - 1;
                                                if (decimalCount > 1) {
                                                    const parts = inputValue.split('.');
                                                    inputValue = parts[0] + '.' + parts.slice(1).join('');
                                                }
                                                const parts = inputValue.split('.');
                                                if (parts[0].length > 7) {
                                                    parts[0] = parts[0].substring(0, 7);
                                                }
                                                if (parts.length > 1) {
                                                    parts[1] = parts[1]?.substring(0, 2);
                                                }
                                                inputValue = parts.join('.');
                                                e.target.value = inputValue;
                                            }}
                                        />
                                    </div>
                                    <ErrorMessage
                                        errors={errors}
                                        name="amount"
                                        render={({ message }) => <p style={{
                                            fontSize: '13px',
                                            color: '#FF0000',
                                            margin: '3px 0 0'

                                        }}>{message}</p>}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label">Expense Type</label>
                                    <div className='custom-select'>
                                        <ReactSelect
                                            options={expensesCategories?.data?.data}
                                            value={watch('ec_id')}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Expense Type"
                                            isLoading={expensesCategories?.loading}
                                            onChange={(selectedOption: any) => {
                                                setValue("ec_id", selectedOption);
                                                trigger("ec_id");
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label">Payer</label>
                                    <div className='custom-select'>
                                        <ReactSelect
                                            value={watch('payer')}
                                            options={[...payers]}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Paid by"
                                            onChange={(selectedOption: any) => {
                                                setValue("payer", selectedOption);
                                                trigger("payer");
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="com-input-grp">
                                    <label className="form-label">
                                        Members Sharing This Expense
                                    </label>
                                    <div className="custom-select share-between-container">
                                        <div className="share-between-header">
                                            <div
                                                className={`btn-link w-100 d-flex justify-content-between align-items-center p-3 ${isShareBetweenExpanded ? '' : 'collapsed'}`}
                                                onClick={() => setIsShareBetweenExpanded(!isShareBetweenExpanded)}
                                            >
                                                <span className="fw-normal">Members</span>
                                                <img src={chevRight} className="chevron-icon" />
                                            </div>
                                        </div>
                                        <div
                                            className={`share-between-collapse ${isShareBetweenExpanded ? 'show' : ''}`}
                                        >

                                            <div className="share-between-body">
                                                {hhMembers?.data?.data?.length > 0
                                                    ? hhMembers?.data?.data?.map(
                                                        (memb: any, membIndex: any) => {
                                                            return (
                                                                <div key={membIndex} className="share-member-item">
                                                                    <div className="d-flex align-items-center gap-3">
                                                                        {/* <img
                                                                            src={memb?.user?.profile_pic}
                                                                            alt={memb?.user?.name}
                                                                            className="member-avatar"
                                                                        /> */}
                                                                        <ProfileImage src={memb?.user?.profile_pic} size={20} />
                                                                        <span className="member-name">
                                                                            {profile?.uuid === memb?.user?.uuid
                                                                                ? `Me`
                                                                                : memb?.user?.name}
                                                                        </span>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <div className="form-check com-check check-green m-0">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                onClick={(e) => {
                                                                                    const payer = watch('payer');
                                                                                    if (!payer) {
                                                                                        e.preventDefault();
                                                                                        toast.error("Please select payer first.");
                                                                                        return;
                                                                                    }
                                                                                    handleSelectShareBetween(memb?.user?.uuid);
                                                                                }}
                                                                                checked={watch(
                                                                                    "s_between"
                                                                                )?.includes(memb?.user?.uuid)}
                                                                            />
                                                                        </div>
                                                                        {/* <Checkbox
                                                                            id={memb?.user?.uuid}
                                                                            onChange={() =>
                                                                                handleSelectShareBetween(memb?.user?.uuid)
                                                                            }
                                                                            checked={watch("s_between")?.includes(
                                                                                memb?.user?.uuid
                                                                            )}
                                                                        /> */}
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    )
                                                    : <div className="text-center py-3 text-muted">No members available</div>}
                                            </div>

                                        </div>
                                        <ErrorMessage
                                            errors={errors}
                                            name="s_between"
                                            render={({ message }) => (
                                                <p className="valid-error">{message}</p>
                                            )}
                                        />
                                    </div>
                                </div>
                                {/* <div className="com-input-grp">
                                    <label className="form-label">Share Between</label>
                                    <div className="custom-select">
                                        <div
                                            className="accordion expenses-accordian"
                                            id="choresAccordian"
                                        >
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#collapseOne"
                                                        aria-expanded="true"
                                                        aria-controls="collapseOne"
                                                    >
                                                        <span className="">Members</span>
                                                    </button>
                                                </h2>
                                                <div
                                                    id="collapseOne"
                                                    className="accordion-collapse collapse show"
                                                    data-bs-parent="#choresAccordian"
                                                >
                                                    <div className="accordion-body">
                                                        <div className="table-responsive">
                                                            <table className="table expenses-accordian-table m-0">
                                                                <tbody>
                                                                    {hhMembers?.data?.data?.length > 0
                                                                        ? hhMembers?.data?.data?.map(
                                                                            (memb: any, membINdex: any) => {
                                                                                console.log("payer ==>", watch("payer"))
                                                                                return (
                                                                                    <tr key={membINdex}>
                                                                                        <td style={{ width: "55px" }}>
                                                                                            <div className="form-check com-check check-green m-0">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    className="form-check-input"
                                                                                                    onClick={() =>
                                                                                                        handleSelectShareBetween(
                                                                                                            memb?.user?.uuid
                                                                                                        )
                                                                                                    }
                                                                                                    checked={watch(
                                                                                                        "s_between"
                                                                                                    )?.includes(memb?.user?.uuid)}
                                                                                                // disabled={watch("payer")?.value === memb?.user?.uuid}
                                                                                                />
                                                                                            </div>
                                                                                        </td>
                                                                                        <td className="expenses-img-wrap">
                                                                                            <img
                                                                                                src={memb?.user?.profile_pic}
                                                                                                alt=""
                                                                                            />
                                                                                        </td>
                                                                                        <td>
                                                                                            {profile?.uuid ===
                                                                                                memb?.user?.uuid
                                                                                                ? `Me`
                                                                                                : memb?.user?.name}
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            }
                                                                        )
                                                                        : ""}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <ErrorMessage
                                                errors={errors}
                                                name="s_between"
                                                render={({ message }) => (
                                                    <p className="valid-error">{message}</p>
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            {/* <div className="col-12">
                                <div className="com-input-grp">
                                    <label className="form-label">Members Sharing This Expense</label>
                                    <div className='custom-select'>
                                        <ReactSelect
                                            value={watch('s_between')}
                                            options={[...payers]}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Paid by"
                                            onChange={(selectedOption: any) => {
                                                setValue("s_between", selectedOption);
                                                trigger("s_between");
                                            }}
                                        />
                                    </div>
                                </div>
                            </div> */}
                            <div className="col-12">
                                <div className="com-input-grp">
                                    <label className="form-label">Description</label>
                                    <div className='custom-select'>
                                        <input type="text" className="form-control" placeholder='Type here' max={24} min={0} value={watch('description')}
                                            onInput={(e: any) => {
                                                let value = e.target.value
                                                if (value === '') {
                                                    setValue('description', '');
                                                    trigger('description');
                                                    return;
                                                }
                                                setValue('description', value);
                                                trigger('description');
                                            }}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="description"
                                            render={({ message }) => <p className='valid-error'>{message}</p>}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='pb-4 d-flex gap-3'>
                                <button className='custom-grayed-btn modal-light-btn btn-close-modal mt-2' style={{ width: "50%" }} data-bs-dismiss="modal" aria-label="Close" disabled={updateExpense?.loading} type="button" onClick={onCancel}>Cancel</button>
                                <Button className='com-btn mt-2' type="submit" text="submit" style={{ width: "50%" }} loading={updateExpense?.loading}>Save</Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditExpenses


// <AnimatePresence>
// {editExpense && (
//     <div className="modal-card-container">

//         <motion.div
//             layoutId={editExpense}
//             className="expanded-card"
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             exit={{ opacity: 0, scale: 0.1 }}
//             transition={{ duration: 0.4 }}
//         >
//             {(() => {
//                 return (
//                     <>

//                         <form className="row gy-3" onSubmit={handleSubmit(onSubmit)}>
//                             <div className="col-12">
//                                 <div className="com-input-grp">
//                                     <label className="form-label">Amount</label>
//                                     <div className='custom-select'>
//                                         <input
//                                             type="text"
//                                             className="form-control"
//                                             placeholder="Enter amount"
//                                             {...register('amount')}
//                                             onInput={(e: any) => {
//                                                 let inputValue = e.target.value;
//                                                 inputValue = inputValue.replace(/[^0-9.]/g, '');
//                                                 const decimalCount = inputValue.split('.').length - 1;
//                                                 if (decimalCount > 1) {
//                                                     const parts = inputValue.split('.');
//                                                     inputValue = parts[0] + '.' + parts.slice(1).join('');
//                                                 }
//                                                 const parts = inputValue.split('.');
//                                                 if (parts[0].length > 7) {
//                                                     parts[0] = parts[0].substring(0, 7);
//                                                 }
//                                                 if (parts.length > 1) {
//                                                     parts[1] = parts[1]?.substring(0, 2);
//                                                 }
//                                                 inputValue = parts.join('.');
//                                                 e.target.value = inputValue;
//                                             }}
//                                         />
//                                     </div>
//                                     <ErrorMessage
//                                         errors={errors}
//                                         name="amount"
//                                         render={({ message }) => <p style={{
//                                             fontSize: '13px',
//                                             color: '#FF0000',
//                                             margin: '3px 0 0'

//                                         }}>{message}</p>}
//                                     />
//                                 </div>
//                             </div>
//                             <div className="col-12">
//                                 <div className="com-input-grp">
//                                     <label className="form-label">Expense Type</label>
//                                     <div className='custom-select'>
//                                         <ReactSelect
//                                             options={expensesCategories?.data?.data}
//                                             value={watch('ec_id')}
//                                             className="com-r-select"
//                                             classNamePrefix="com-r-select"
//                                             placeholder="Expense Type"
//                                             isLoading={expensesCategories?.loading}
//                                             onChange={(selectedOption: any) => {
//                                                 setValue("ec_id", selectedOption);
//                                                 trigger("ec_id");
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12">
//                                 <div className="com-input-grp">
//                                     <label className="form-label">Payer</label>
//                                     <div className='custom-select'>
//                                         <ReactSelect
//                                             value={watch('payer')}
//                                             options={payers}
//                                             className="com-r-select"
//                                             classNamePrefix="com-r-select"
//                                             placeholder="Paid by"
//                                             onChange={(selectedOption: any) => {
//                                                 setValue("payer", selectedOption);
//                                                 trigger("payer");
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className='page-padding-x pb-4 d-flex'>
//                                 <Button className='com-btn mt-2 me-4' type="submit" text="submit" loading={updateExpense?.loading}>Save</Button>
//                                 <Button className='com-btn com-btn-outline mt-2 me-4' loading={updateExpense?.loading} onClick={handleCancel}>Cancel</Button>
//                             </div>
//                         </form>
//                     </>
//                 );
//             })()}
//         </motion.div>
//     </div>
// )}
// </AnimatePresence>
